import type { ReporterAiMode } from "../../atoms/reporterPrefsAtoms";

const OPTIONS: { value: ReporterAiMode; label: string; title: string }[] = [
  { value: "inline", label: "Inline", title: "AI chips auto-fill the report" },
  { value: "strip", label: "Strip", title: "AI suggestions sit above the report" },
  { value: "off", label: "No AI", title: "No AI suggestions (baseline)" },
];

interface ReporterModeToggleProps {
  mode: ReporterAiMode;
  onChange: (mode: ReporterAiMode) => void;
}

/**
 * Three-radio control for the A/B mode. Persists per-radiologist via
 * useUserPrefs. Lives at the top of the report column.
 */
export function ReporterModeToggle({ mode, onChange }: ReporterModeToggleProps) {
  return (
    <div
      className="reporter-mode-toggle"
      role="radiogroup"
      aria-label="Reporter AI mode"
      data-testid="reporter-mode-toggle"
    >
      {OPTIONS.map((opt) => {
        const isActive = mode === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={isActive}
            title={opt.title}
            data-testid={`reporter-mode-${opt.value}`}
            className={`reporter-mode-toggle__option ${isActive ? "reporter-mode-toggle__option--active" : ""}`}
            onClick={() => onChange(opt.value)}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
}
